export const europeanCountriesList = [
  'Russia',
  'Germany',
  'United Kingdom',
  'France',
  'Italy',
  'Spain',
  'Ukraine',
  'Poland',
  'Romania',
  'Netherlands',
  'Belgium',
  'Czech Republic',
  'Greece',
  'Portugal',
  'Sweden',
  'Hungary',
  'Belarus',
  'Austria',
  'Serbia',
  'Switzerland',
  'Bulgaria',
  'Denmark',
  'Finland',
  'Slovakia',
  'Norway',
  'Ireland',
  'Croatia',
  'Moldova',
  'Bosnia',
  'Albania',
  'Lithuania',
  'North Macedonia',
  'Slovenia',
  'Latvia',
  'Estonia',
  'Montenegro',
  'Luxembourg',
  'Malta',
  'Iceland',
  'Andorra',
  'Monaco',
  'Liechtenstein',
  'San Marino',
  'Holy See',
]
